<template>
  <form @submit.prevent="onSubmit">
    <div class="input-label">Job Profile Name:</div>
    <b-form-group class="my-2">
      <b-form-input
        type="text"
        v-model="$v.title.$model"
        placeholder="Enter Job Profile Name"
        :state="validateState('title')"
        class="phairify-color-grey phairify-border-grey phairify-border-rounded"
        @input="isNotUnique = false"
      />
      <b-form-invalid-feedback>
        {{ titleInvalidFeedback }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-button
      type="submit"
      size="sm"
      class="float-right mt-2 px-4"
      variant="primary"
      :disabled="continueLoading"
    >
      <template v-if="!continueLoading">Continue</template>
      <template v-else>
        <b-spinner small />
        <span>Copying...</span>
      </template>
    </b-button>
    <b-button size="sm" class="mt-2 px-4" variant="secondary" @click="onCancel">
      Cancel
    </b-button>
  </form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { COPY_JOB_PROFILE_ACTION } from '@/store/jobProfiles';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';

export default {
  name: 'JobProfileCopyForm',
  props: {
    initialData: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
    jobProfileId: {
      type: Number,
      required: true,
    },
  },
  mixins: [validationMixin],
  data: function () {
    return {
      title: this.initialData ? this.initialData.title : '',
      continueLoading: false,
      isNotUnique: false,
    };
  },
  validations: {
    title: {
      required,
      isUnique(value, component) {
        return !component.isNotUnique;
      },
    },
  },
  computed: {
    titleInvalidFeedback: function () {
      if (!this.$v.title.isUnique) {
        return 'The Job Profile Title must be unique';
      }
      return 'Name is required';
    },
  },
  methods: {
    onSubmit: async function () {
      this.$v.$touch();

      if (this.$v.$anyError || this.continueLoading) {
        return;
      }

      this.continueLoading = true;

      try {
        const newProfile = await this.$store.dispatch(COPY_JOB_PROFILE_ACTION, {
          id: this.jobProfileId,
          title: this.title,
        });

        this.$emit('form-submit', this.title);
        this.reset();

        this.$router.push(`/user/exchange/job-profile/${(newProfile || {}).id}`);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message &&
          error.response.data.message.includes('unique')
        ) {
          this.isNotUnique = true;
        }
      } finally {
        this.continueLoading = false;
      }
    },
    validateState: function (name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    onCancel: function () {
      this.reset();
      this.$emit('cancel');
    },
    reset: function () {
      this.title = '';
      this.$v.$reset();
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/variables_mixins';

.input-label {
  @include phairify_body_copy;
  font-weight: bold;
  color: $phairify_primary_color_teal;
}
</style>
